import './App.css';
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import ShopCategory from "./pages/ShopCategory";
import Product from "./pages/Product";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Navbar/>
                <Routes>
                    <Route path="/" element= {<ShopCategory category="General"/>}/>
                    <Route path="/Keychain" element= {<ShopCategory category="Keychain"/>}/>
                    <Route path="/Pen" element= {<ShopCategory category="Pen" />}/>
                    <Route path="/Candle_holders" element= {<ShopCategory category="Candle_holders" />}/>
                    <Route path="/product" element={<Product/>}>
                        <Route path=':productId' element={<Product/>}/>
                    </Route>
                </Routes>
                <Footer/>
            </BrowserRouter>
        </div>
    );
}

export default App;
